import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
    IonText,
    IonGrid,
    IonRow,
    IonCol,
    IonContent,
    IonHeader, IonPage, IonTitle, IonToolbar,
    IonBackButton,
    IonButtons,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    setupIonicReact,
    IonButton,
    IonRouterContext,
    IonRouteProps,
    IonLoading,
    IonToast,
    IonFab,
    IonFabButton,
    IonPopover,
    IonList,
    IonSegment,
    IonSegmentButton,
    IonCard,
    IonCardHeader,
    IonCardContent,
    IonCardTitle,
    IonItem,
    IonBadge,
    IonModal,
    IonIcon,
    IonRefresher,
    IonRefresherContent,
    IonFooter
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { ticketOutline, ellipsisVerticalOutline, cubeOutline, albumsOutline, closeOutline, bedOutline } from 'ionicons/icons';
import './rooms.css';
import { getLoginApp, getchek } from '../../utils/functions';
import { API } from '../../constants/system';
import { baseurl } from '../../constants/constants';
import RoomsActions from '../../actions/RoomsActions';
import Countdown from "react-countdown";
import moment from 'moment';
import Select from 'react-select'

interface IProps {
    setData_: any;
    get_: any;
    post_: any;
}

interface IState {
    data_login_ari_app: any;
    dataRooms: any;
    RoomAreasWithRooms: any;
    status_color: any;
    reserva: any;
    show_modal_reserva: boolean;
    selected_room: any;
    reserve_room_ocupation: any;
    status: any;
    transports: any;
    filter_status: any;
    filter_category: any;
    filter_room: any;
    RoomAreas: any;
    loading: boolean;
    formErrors: any;
    simpleToast: boolean;
    response: any;
}

class Backup extends React.Component<IProps, IState> {
    contentRef: React.RefObject<HTMLIonContentElement>;
    intervalId: any = null;
    handleVisibilityChange: any;
    constructor(props: any) {
        super(props)

        this.contentRef = React.createRef<HTMLIonContentElement>();

        this.state = {
            data_login_ari_app: props.data_login_ari_app,
            dataRooms: props.dataRooms,
            RoomAreasWithRooms: props.RoomAreasWithRooms,
            status_color: props.status_color,
            reserva: props.reserva,
            show_modal_reserva: false,
            selected_room: null,
            reserve_room_ocupation: null,
            status: [],
            transports: [],
            filter_status: null,
            filter_category: null,
            filter_room: null,
            RoomAreas: [],
            loading: false,
            formErrors: {},
            simpleToast: false,
            response: null
        };

        this.close_modal_reserva = this.close_modal_reserva.bind(this);

        // Bind visibility handler
        this.handleVisibilityChange = this.handleVisibilityChangeMethod.bind(this);
    }

    ionViewDidEnter() {
        // Este es el método correcto en Ionic para realizar tareas después de que el componente ha entrado en la vista
        console.log('El componente ha entrado en la vista');
        // Cargar datos, inicializar, etc.
    }

    componentDidMount() {
        let data_login_ari_app: any = !getLoginApp() ? [] : getLoginApp();
        this.setState({
            data_login_ari_app: data_login_ari_app,
            reserve_room_ocupation: {
                room_id: null,
                id: null,
                transport: null,
                modelo: null,
                placa: null,
                color: null,
                observacion: null,
                status: null
            }
        });

        setTimeout(this.get_reserve_room.bind(this), 100);
        this.startInterval();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    componentWillUnmount() {
        this.clearInterval();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChangeMethod() {
        if (document.visibilityState === 'visible') {
            // Al volver a la pestaña, refresca y reinicia el intervalo
            this.get_reserve_room();
            this.startInterval();
        } else {
            // Al salir de la pestaña, limpia el intervalo
            this.clearInterval();
        }
    }

    startInterval() {
        this.clearInterval();
        this.intervalId = setInterval(this.get_reserve_room.bind(this), 10000);
    }

    clearInterval() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            loading: nextProps.data.loading && nextProps.data.loading.isOpen ? nextProps.data.loading.isOpen : false,
            dataRooms: nextProps.data.dataRooms,
            RoomAreasWithRooms: nextProps.data.dataRooms && nextProps.data.dataRooms.RoomAreasWithRooms && nextProps.data.dataRooms.RoomAreasWithRooms.length > 0 ? nextProps.data.dataRooms.RoomAreasWithRooms : [],
            status_color: nextProps.data.dataRooms && nextProps.data.dataRooms.status_color,
            status: nextProps.data.dataRooms && nextProps.data.dataRooms.status,
            transports: nextProps.data.dataRooms && nextProps.data.dataRooms.transports,
            RoomAreas: nextProps.data.dataRooms && nextProps.data.dataRooms.RoomAreas && nextProps.data.dataRooms.RoomAreas.length > 0 ? nextProps.data.dataRooms.RoomAreas : [],
            simpleToast: nextProps.data.simpleToast,
            response: nextProps.data.response
        });
        console.log(nextProps.data.response);
        if (nextProps.data.refresh_list && nextProps.data.response && (nextProps.data.response.action == 'save_reserve_room' || nextProps.data.response.action == 'update_reserve_room')) {
            setTimeout(this.get_reserve_room.bind(this), 2000);
        }
    }

    get_reserve_room() {
        let data_login_ari_app = this.state.data_login_ari_app;
        this.props.get_({
            typeOption: 'get_reserve_room',
            user_id: data_login_ari_app.id,
            status_id: this.state.filter_status,
            area_rooms_id: this.state.filter_category
        }, "api/get_reserve_room");
    }

    render_areas_rooms(areas: any, key: any) {
        let rooms = areas.rooms && areas.rooms.length > 0 ? areas.rooms : [];
        let render_rooms = [];
        if (rooms && rooms.length > 0) {
            render_rooms = rooms.map((room: any, key_room: any) => {
                const roomElement = document.getElementById(`room_${room.id}`);
                if (roomElement && roomElement.classList.contains('border-rgb')) {
                    roomElement.classList.remove('border-rgb');
                }
                let start_time = null;
                let start_time_plane = null;
                let preparation_time_in_minutes = 0;
                if (room.reserve_room_ocupation) {
                    // Usa created_at si existe, si no usa start_time
                    const timeString = room.reserve_room_ocupation.created_at_formatted;
                    start_time = timeString
                        ? moment(timeString).format('h:mm A')
                        : null;

                    start_time_plane = room.reserve_room_ocupation.created_at_formatted;
                }
                if (room.reserve_room_ocupation && Array.isArray(room.reserve_room_ocupation.transactions)) {
                    room.reserve_room_ocupation.transactions.forEach((transaction: any) => {
                        let sell_lines = transaction.sell_lines;
                        if (sell_lines && sell_lines.length > 0) {
                            sell_lines.forEach((line: any) => {
                                if (line.product && line.product.preparation_time_in_minutes) {
                                    preparation_time_in_minutes += parseInt(line.product.preparation_time_in_minutes) * line.quantity;
                                }
                            });
                        }
                    });
                }

                let corre_tiempo = false;
                let tiemporender = null;
                let color_card: any = 'bg-gradient-status-disponible';
                let tiempo_finalizado = false;
                if (
                    room.reserve_room_ocupation
                    && room.reserve_room_ocupation.created_at
                    && room.reserve_room_ocupation.status == 'ocupado'
                ) {
                    corre_tiempo = true;
                    if (corre_tiempo && start_time_plane) {
                        // Calcula el tiempo de finalización sumando los minutos de preparación
                        const endTime = moment(start_time_plane).add(preparation_time_in_minutes, 'minute').toDate();

                        // Renderiza el Countdown dentro del Card
                        tiemporender =
                            <Countdown
                                date={endTime}
                                onComplete={() => {
                                    // El tiempo ha finalizado para la habitación
                                    console.log('El tiempo ha finalizado para la habitación:', room.id);
                                    // Agrega la clase 'border-rgb' al elemento con id `room_${room.id}`
                                    const roomElement = document.getElementById(`room_${room.id}`);
                                    if (roomElement && !roomElement.classList.contains('border-rgb')) {
                                        roomElement.classList.add('border-rgb');
                                    }
                                }}
                                renderer={({ hours, minutes, seconds, completed }) => {
                                    // tiempo_finalizado es true si faltan 15 minutos o menos, o si está completado
                                    const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
                                    if (completed || totalSeconds <= 900) {
                                        const roomElement = document.getElementById(`room_${room.id}`);
                                        if (roomElement && !roomElement.classList.contains('border-rgb')) {
                                            roomElement.classList.add('border-rgb');
                                        }
                                    }
                                    // Puedes usar tiempo_finalizado para cambiar el estilo o mostrar una alerta visual
                                    return completed ? (
                                        <span style={{ color: 'white', fontWeight: 'bold', backgroundColor: '#5b1566' }}>¡Tiempo finalizado!</span>
                                    ) : (
                                        <span style={{ color: 'white', fontWeight: 'bold', backgroundColor: '#5b1566' }}>
                                            {String(hours).padStart(2, '0')} : {String(minutes).padStart(2, '0')} : {String(seconds).padStart(2, '0')}
                                        </span>
                                    );
                                }}
                            />

                    }
                    color_card = this.state.status_color[room.reserve_room_ocupation.status] || '';
                } else {
                    color_card = room.reserve_room_ocupation && this.state.status_color[room.reserve_room_ocupation.status] || 'bg-gradient-status-disponible';
                }
                return (
                    <IonCol
                        id={`room_${room.id}`}
                        col-12
                        size='12'
                        key={key + "_room_" + room.id}
                        className={`${color_card}`}
                        style={{ marginTop: '5px' }}
                        onClick={() => this.open_modal_reserva(room)}
                    >
                        <IonRow>
                            <IonCol col-8 size='8'>
                                <IonIcon icon={bedOutline} style={{ color: 'white', marginRight: 8, verticalAlign: 'middle' }} />
                                <strong style={{ color: 'white', fontWeight: 'bold' }}>{room.title}</strong>
                            </IonCol>
                            <IonCol col-4 size='4'>
                                {tiemporender && (
                                    <IonBadge color="primary">{tiemporender}</IonBadge>
                                )}
                            </IonCol>
                            <IonCol col-12 size='12' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {
                                    room.reserve_room_ocupation && room.reserve_room_ocupation.status ?
                                        <span style={{
                                            color: 'white',
                                            fontWeight: 'bold',
                                            backgroundColor: '#5b1566',
                                            borderRadius: '5px',
                                            padding: '2px 2px',
                                            fontSize: '12px'
                                        }}>
                                            {this.state.status
                                                .filter((s: any) => s.id === room.reserve_room_ocupation.status)
                                                .map((s: any) => s.name)
                                                .join(', ')
                                            }
                                        </span>
                                        :
                                        <span style={{
                                            color: 'white',
                                            fontWeight: 'bold',
                                            backgroundColor: '#5b1566',
                                            borderRadius: '5px',
                                            padding: '2px 2px',
                                            fontSize: '12px'
                                        }}>
                                            Disponible
                                        </span>
                                }
                            </IonCol>
                            <IonCol col-6 size='6'>
                                <IonLabel>
                                    <p style={{ color: 'white' }}>Hora Entrada: {start_time ?? '--:--'}</p>
                                    <p style={{ color: 'white' }}>
                                        Transp: {(room.reserve_room_ocupation && room.reserve_room_ocupation.transport)
                                            ? (typeof room.reserve_room_ocupation.transport === 'string'
                                                ? room.reserve_room_ocupation.transport
                                                : (room.reserve_room_ocupation.transport?.name || room.reserve_room_ocupation.transport?.id || 'N/A'))
                                            : 'N/A'}
                                    </p>
                                </IonLabel>
                            </IonCol>
                            <IonCol col-6 size='6'>
                                <IonLabel>
                                    <p style={{ color: 'white' }}>
                                        No Placa: {(room.reserve_room_ocupation && room.reserve_room_ocupation.placa) ? room.reserve_room_ocupation.placa : 'N/A'}
                                    </p>
                                    
                                </IonLabel>
                            </IonCol>
                        </IonRow>
                    </IonCol>
                );
            });
        }
        return (
            <IonRow key={key + "_area_" + areas.id} style={{ padding: '5px' }}>
                <h5>{areas.title}</h5>
                {render_rooms}
            </IonRow>
        );
    }

    open_modal_reserva(room: any) {
        let reserve_room_ocupation = {
            room_id: room.id,
            id: (room.reserve_room_ocupation && room.reserve_room_ocupation.id) ?? null,
            transport: (room.reserve_room_ocupation && room.reserve_room_ocupation.transport) ?? null,
            modelo: (room.reserve_room_ocupation && room.reserve_room_ocupation.modelo) ?? null,
            placa: (room.reserve_room_ocupation && room.reserve_room_ocupation.placa) ?? null,
            color: (room.reserve_room_ocupation && room.reserve_room_ocupation.color) ?? null,
            observacion: (room.reserve_room_ocupation && room.reserve_room_ocupation.observacion) ?? null,
            status: (room.reserve_room_ocupation && room.reserve_room_ocupation.status) ?? null
        }
        this.setState({
            show_modal_reserva: true,
            selected_room: room,
            reserve_room_ocupation: reserve_room_ocupation
        });
    }

    close_modal_reserva(ev: any) {
        this.setState({
            show_modal_reserva: false,
            selected_room: null,
            reserve_room_ocupation: {
                room_id: null,
                id: null,
                transport: null,
                modelo: null,
                placa: null,
                color: null,
                observacion: null,
                status: null
            }
        });
    }

    handleChange_reserve_room_ocupation(ev: any) {
        const { name, value } = ev.target;
        this.setState({
            reserve_room_ocupation: {
                ...this.state.reserve_room_ocupation,
                [name]: value
            }
        });
    }

    handleChange_filter(ev: any) {
        const { name, value } = ev.target;
        this.setState({
            ...this.state,
            [name]: value
        });
        setTimeout(this.get_reserve_room.bind(this), 200);
    }

    handleRefresh(event: any) {

        setTimeout(() => {
            event.detail.complete();
        }, 2000);
        setTimeout(this.get_reserve_room.bind(this), 200);
    }

    SaveDataPost() {
        let reserve_room_ocupation = this.state.reserve_room_ocupation;

        let error = false;
        let formErrors: any = {};

        if (reserve_room_ocupation && (!reserve_room_ocupation.status || reserve_room_ocupation.status === "")) {
            formErrors['status'] = "*Campo Requerido";
            error = true;
        };

        if (error) {
            this.setState({
                formErrors: formErrors
            });
        } else {
            if (reserve_room_ocupation.id) {
                this.props.post_({
                    typeOption: 'update_reserve_room',
                    action: 'update',
                    user_id: this.state.data_login_ari_app.id,
                    view_active: 'dashboard_pos/contacts',
                    id: reserve_room_ocupation.id,
                    room_id: reserve_room_ocupation.room_id,
                    transport: reserve_room_ocupation.transport,
                    modelo: reserve_room_ocupation.modelo,
                    placa: reserve_room_ocupation.placa,
                    color: reserve_room_ocupation.color,
                    observacion: reserve_room_ocupation.observacion,
                    status: reserve_room_ocupation.status,
                }, "api/update_reserve_room/" + reserve_room_ocupation.id);
            } else {
                this.props.post_({
                    typeOption: 'save_reserve_room',
                    action: 'create',
                    user_id: this.state.data_login_ari_app.id,
                    id: reserve_room_ocupation.id,
                    room_id: reserve_room_ocupation.room_id,
                    transport: reserve_room_ocupation.transport,
                    modelo: reserve_room_ocupation.modelo,
                    placa: reserve_room_ocupation.placa,
                    color: reserve_room_ocupation.color,
                    observacion: reserve_room_ocupation.observacion,
                    status: reserve_room_ocupation.status,
                    view_active: 'dashboard_pos/contacts',
                    date: moment().format('YYYY-MM-DD HH:mm:ss')
                }, "api/save_reserve_room");
            }
            this.setState({
                show_modal_reserva: false
            });
        }
    }
    onDidDismissToast(e: any) {
        this.props.setData_({ response: {}, simpleToast: false });
    }
    render() {
        const { formErrors, simpleToast, response, dataRooms, RoomAreasWithRooms, show_modal_reserva, selected_room, reserve_room_ocupation, status, transports, filter_status, loading, RoomAreas, filter_category } = this.state;
        let data_render_areas_rooms = [];
        if (RoomAreasWithRooms && RoomAreasWithRooms.length > 0) {
            data_render_areas_rooms = [];
            data_render_areas_rooms = RoomAreasWithRooms.map((val: any, key: any) =>
                this.render_areas_rooms(val, key)
            );
        }
        return (
            <IonPage>
                {
                    response && Object.keys(response).length > 0 && response.Msg ?
                        <IonToast
                            isOpen={simpleToast}
                            message={`${response && response.Msg && response.Msg !== '' ? response.Msg : ''}`}
                            duration={2000}
                            onDidDismiss={e => this.onDidDismissToast(e)}
                        /> : null
                }
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonButtons slot="start">
                            <IonBackButton defaultHref="/home" text={""} />
                        </IonButtons>
                        <IonTitle style={{ fontSize: "15px" }}>PANEL</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen ref={this.contentRef} scrollEvents={true}>
                    <IonLoading
                        //color="light"
                        cssClass='my-custom-class'
                        isOpen={loading}
                        message={'Cargando...'}
                    />
                    <IonRefresher slot="fixed" onIonRefresh={(e) => this.handleRefresh(e)}>
                        <IonRefresherContent></IonRefresherContent>
                    </IonRefresher>
                    <IonRow>
                        <IonCol col-6 size='6'>
                            <label>Categoria de Habitaciones: </label>
                            <Select
                                className='inputformselect'
                                onChange={(e: any) => this.handleChange_filter({ target: { name: 'filter_category', value: e.value } })}
                                placeholder="Categorias"
                                name='filter_category'
                                menuPortalTarget={document.querySelector('body')}
                                isSearchable={false}
                                options={
                                    RoomAreas && RoomAreas.map((value: any) => (
                                        { label: value.name, value: value.id }
                                    ))
                                }
                                styles={{
                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                }}
                                defaultValue={filter_category ?
                                    RoomAreas && RoomAreas.length > 0 ?
                                        { label: RoomAreas.filter((item: any) => item.id == filter_category)[0].name, value: RoomAreas.filter((item: any) => item.id == filter_category)[0].id }
                                        : null
                                    : null
                                }
                            />
                        </IonCol>
                        <IonCol col-6 size='6'>
                            <label>Estado: </label>
                            <Select
                                className='inputformselect'
                                onChange={(e: any) => this.handleChange_filter({ target: { name: 'filter_status', value: e.value } })}
                                placeholder="Estado"
                                name='filter_status'
                                menuPortalTarget={document.querySelector('body')}
                                isSearchable={false}
                                options={
                                    status && status.map((value: any) => (
                                        { label: value.name, value: value.id }
                                    ))
                                }
                                styles={{
                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                }}
                                defaultValue={filter_status ?
                                    status && status.length > 0 ?
                                        { label: status.filter((item: any) => item.id == filter_status)[0].name, value: status.filter((item: any) => item.id == filter_status)[0].id }
                                        : null
                                    : null
                                }
                            />
                        </IonCol>

                    </IonRow>
                    {data_render_areas_rooms}
                    <IonModal onWillDismiss={this.close_modal_reserva} isOpen={show_modal_reserva ?? false}>
                        <IonHeader>
                            <IonToolbar color='primary'>
                                <IonTitle>{(selected_room && selected_room.title) ?? ""}</IonTitle>
                                <IonButton slot="end" color='primary' onClick={(ev) => this.close_modal_reserva(ev)}>
                                    <IonIcon slot="end" icon={closeOutline} onClick={(ev) => this.close_modal_reserva(ev)}></IonIcon>
                                </IonButton>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            <IonRow>
                                <IonCol col-12 size='12'>
                                    <label>Transporte: </label>
                                    <Select
                                        className='inputformselect'
                                        onChange={(e: any) => this.handleChange_reserve_room_ocupation({ target: { name: 'transport', value: e.value } })}
                                        placeholder="Transporte"
                                        name='transport'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={
                                            transports && transports.map((value: any) => (
                                                { label: value.name, value: value.id }
                                            ))
                                        }
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={reserve_room_ocupation && reserve_room_ocupation.transport ?
                                            transports && transports.length > 0 ?
                                                { label: transports.filter((item: any) => item.id == reserve_room_ocupation.transport)[0].name, value: transports.filter((item: any) => item.id == reserve_room_ocupation.transport)[0].id }
                                                : null
                                            : null
                                        }
                                    />
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Marca Modelo: </label>

                                    <input className='inputform' type="text" placeholder="Marca Modelo"
                                        onChange={this.handleChange_reserve_room_ocupation.bind(this)}
                                        value={(reserve_room_ocupation && reserve_room_ocupation.modelo) ?? ""}
                                        name="modelo" />

                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Placa: </label>

                                    <input className='inputform' type="text" placeholder="Placa"
                                        onChange={this.handleChange_reserve_room_ocupation.bind(this)}
                                        value={(reserve_room_ocupation && reserve_room_ocupation.placa) ?? ""}
                                        name="placa" />

                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Color: </label>

                                    <input className='inputform' type="text" placeholder="Color"
                                        onChange={this.handleChange_reserve_room_ocupation.bind(this)}
                                        value={(reserve_room_ocupation && reserve_room_ocupation.color) ?? ""}
                                        name="color" />

                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Observación: </label>

                                    <textarea className='inputform' rows={3} placeholder="Observación"
                                        onChange={this.handleChange_reserve_room_ocupation.bind(this)}
                                        value={(reserve_room_ocupation && reserve_room_ocupation.observacion) ?? ""}
                                        name="observacion" />

                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <label>Estado (*): </label>
                                    <Select
                                        className='inputformselect'
                                        onChange={(e: any) => this.handleChange_reserve_room_ocupation({ target: { name: 'status', value: e.value } })}
                                        placeholder="Estado"
                                        name='status'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={
                                            status && status.map((value: any) => (
                                                { label: value.name, value: value.id }
                                            ))
                                        }
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={reserve_room_ocupation && reserve_room_ocupation.status ?
                                            status && status.length > 0 ?
                                                { label: status.filter((item: any) => item.id == reserve_room_ocupation.status)[0].name, value: status.filter((item: any) => item.id == reserve_room_ocupation.status)[0].id }
                                                : null
                                            : null
                                        }
                                    />
                                    {formErrors && formErrors.status && (
                                        <>
                                            <IonText color="danger" className="ion-padding-start">
                                                <small>{formErrors.status}</small>
                                            </IonText>
                                            <br />
                                        </>
                                    )}
                                </IonCol>
                            </IonRow>
                        </IonContent>
                        <IonFooter collapse="fade" className='footerfixed'>
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton color="dark" onClick={(ev) => this.close_modal_reserva(ev)}>
                                        Cancel
                                    </IonButton>
                                </IonButtons>
                                <IonButtons slot="end">
                                    <IonButton color="primary" strong={true} onClick={() => this.SaveDataPost()}>
                                        Guardar
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonFooter>
                    </IonModal>
                </IonContent>
            </IonPage>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        setData: PropTypes.func.isRequired,
        data: state.data,
        _get: PropTypes.func.isRequired,
        post_: PropTypes.func.isRequired,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        get_: (fields: any, controller: string) => dispatch(RoomsActions.get_(fields, controller)),
        post_: (fields: any, controller: string) => dispatch(RoomsActions.post_(fields, controller)),
        setData_: (data: any) => dispatch(RoomsActions.setData(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Backup);
